var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.labels.heading_size === 'h2')?_c('h2',{staticClass:"heading-m"},[_vm._v(" "+_vm._s(_vm.labels.heading_text)+" ")]):_vm._e(),(_vm.labels.heading_size === 'h3')?_c('h3',{staticClass:"heading-s"},[_vm._v(" "+_vm._s(_vm.labels.heading_text)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }